module.exports = __webpack_public_path__ + "static/media/background-card-footer.16d6621d.svg";